import { ActionContext, Module } from 'vuex'
import {Company, User} from '../types/freshchat'
import { FreshChatState, RootState } from './state_models'

export const freshchat: Module<FreshChatState, RootState> = {
  namespaced: true,
  state: {
    userData:{},
    companyData:{}
  } as FreshChatState,
  getters: {
    getCompanyData(state: FreshChatState) {
      return state.companyData;
    },
    getUserData(state: FreshChatState) {
      return state.userData
    },
  },
  mutations: {
    setCompanyData (state, data) {
      state.companyData = data;
    },
    setUserData (state, data) {
      state.userData = data;
    },
  },
  actions: {
    syncCompanyData(
      context: ActionContext<FreshChatState, RootState>,
      payload:  Company ,
    ) {
      context.commit('setCompanyData', payload);
    },
    syncUserData(
      context: ActionContext<FreshChatState, RootState>,
      payload: User ,
    ) {
      context.commit('setUserData', payload);
    },
  }
}
